import React from 'react'

export default function ExampleSocialCard({img,size}) {
  return (
    <div className="exampleSocialCard" style={{background:`url(${img})`,backgroundSize:`${size}`,backgroundPosition:"center",backgroundRepeat:"no-repeat", backgroundColor:"white"}}></div>
  )
}
